import MealCardsList from './components/MealCardsList'
import MealCardActions from './components/MealCardActions'
import TableHeaderTitle from '../../../components/TableHeaderTitle'
import { Box, Container, Paper } from '@mui/material'

const MealCards = () => {
    return (
        <Container maxWidth={false} sx={{
            flexGrow: 1,
            padding: { xs: '110px 8px 0 8px', sm: '110px 12px 0 12px', md: '110px 32px 0 32px', lg: '110px 40px 0 40px' },
            background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
            minHeight: '100vh'
        }}>
            {/* Main Dashboard Container */}
            <Paper
                elevation={0}
                sx={{
                    borderRadius: 4,
                    background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.8) 100%)',
                    backdropFilter: 'blur(20px)',
                    border: '1px solid rgba(255,255,255,0.3)',
                    boxShadow: '0 20px 40px rgba(0,0,0,0.08)',
                    overflow: 'hidden',
                    position: 'relative',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        height: '6px',
                        background: 'linear-gradient(90deg, #1e3c72 0%, #2a5298 25%, #3b82f6 50%, #2a5298 75%, #1e3c72 100%)',
                    }
                }}
            >
                <Box sx={{
                    py: { xs: 2, sm: 3, md: 4 },
                    pb: 2,
                    px: 0,
                    background: 'linear-gradient(135deg, rgba(30, 60, 114, 0.03) 0%, rgba(42, 82, 152, 0.06) 100%)',
                    borderBottom: '1px solid rgba(226, 232, 240, 0.8)'
                }}>
                    <Box sx={{ px: { xs: 2, sm: 3 }, mx: { xs: 0, sm: 2 } }}>
                        <MealCardActions />

                        <Paper
                            elevation={0}
                            sx={{
                                mt: 3,
                                borderRadius: 3,
                                background: 'rgba(255,255,255,0.7)',
                                backdropFilter: 'blur(10px)',
                                border: '1px solid rgba(226, 232, 240, 0.8)',
                                overflow: 'hidden',
                                position: 'relative'
                            }}
                        >
                            {/* Table Header */}
                            <Box sx={{
                                p: 3,
                                pb: 2,
                                background: 'linear-gradient(135deg, rgba(248, 250, 252, 0.8) 0%, rgba(241, 245, 249, 0.9) 100%)',
                                borderBottom: '1px solid rgba(226, 232, 240, 0.6)'
                            }}>
                                <TableHeaderTitle title="Yemek Kart Listesi" />
                            </Box>

                            {/* Table Content */}
                            <Box sx={{ p: 3 }}>
                                <MealCardsList />
                            </Box>
                        </Paper>
                    </Box>
                </Box>
            </Paper>
        </Container>
    )
}

export default MealCards